import SafetyRow from '@/components/safety-row';

type PassThroughToSafetyRowProps = {
  starColor?: string;
  maxStars?: number;
  starAriaDescription?: string;
};

type OptionalSafetyRowProps = PassThroughToSafetyRowProps & {
  label: string;
  feature?: string | number | null;
  unit?: string;
  tooltip?: JSX.Element;
};

const OptionalSafetyRow = ({ label, feature, unit = '', tooltip, ...safetyRowProps }: OptionalSafetyRowProps) => {
  if (!feature) {
    return null;
  }

  const valueForRow = unit ? `${feature}${unit}` : feature;

  return (
    // @ts-expect-error - SafetyRow needs to be typed.
    <SafetyRow label={label} feature={valueForRow} tooltip={tooltip} {...safetyRowProps} />
  );
};

export default OptionalSafetyRow;
